import { colors } from 'styles/colors';

/** Shared palette for the consumer footer (dark theme). */
export const BG = '#1B1917';
export const HEADING = colors.white;
export const LINK = colors.dark.D200;
export const MUTED = '#79736B';
/** Hairline used for dividers, social-icon chips and accordion borders. */
export const BORDER = '#2A2724';
